import { render, staticRenderFns } from "./list-columns.vue?vue&type=template&id=c47e98be&"
import script from "./list-columns.vue?vue&type=script&lang=js&"
export * from "./list-columns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports